var _style, _circle, _g, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewtrends(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;fill:#E1FFF6;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#10B981;}\n\t.st2{fill:none;stroke:#10B981;stroke-width:2;stroke-miterlimit:10;}\n\t.st3{fill:#10B981;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 36,
    cy: 36,
    r: 35.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.1,68.6H6.9c-2.1,0-2.1-3.2,0-3.2h58.2C67.2,65.4,67.2,68.6,65.1,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,68.6c-0.8,0-1.7-0.7-1.7-1.7V36.6h-7.4v30.3c0,2.1-3.2,2.1-3.2,0V35.1c0-0.8,0.7-1.7,1.7-1.7H24 c0.8,0,1.7,0.7,1.7,1.7V67C25.5,67.9,24.8,68.6,24,68.6L24,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.1,26.7c-1.7,0-2.2-2.2-0.8-3l32.9-19c1.8-1.1,3.4,1.8,1.7,2.8L20,26.6C19.7,26.7,19.4,26.7,19.1,26.7 L19.1,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.4,14.4c-1.1,0-1.9-1.1-1.5-2.2l1.9-4.8C46.5,6.9,43,7,43.4,4.8c0.1-0.8,1-1.5,1.8-1.4l7.2,1.1 c1,0.1,1.7,1.2,1.2,2.2l-2.6,6.7C50.7,14,50.1,14.4,49.4,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.1,68.6c-0.8,0-1.7-0.7-1.7-1.7V8.8c0-2.1,3.2-2.1,3.2,0v58.1C66.6,67.9,65.9,68.6,65.1,68.6L65.1,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.3,68.6c-0.8,0-1.7-0.7-1.7-1.7V30.1h-7.4v36.8c0,2.1-3.2,2.1-3.2,0V28.5c0-0.8,0.7-1.7,1.7-1.7h10.6 c0.8,0,1.7,0.7,1.7,1.7v38.4C43,67.9,42.3,68.6,41.3,68.6L41.3,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.8,68.6c-0.8,0-1.7-0.7-1.7-1.7V23.7h-7.4V67c0,2.1-3.2,2.1-3.2,0V22c0-0.8,0.7-1.7,1.7-1.7h10.6 c0.8,0,1.7,0.7,1.7,1.7v44.9C60.3,67.9,59.6,68.6,58.8,68.6z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.4,
    y: -0.4,
    className: "st2",
    width: 19,
    height: 20.4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93.7,
    y: 30,
    className: "st3",
    width: 19,
    height: 20.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewtrends);
export default __webpack_public_path__ + "static/media/new trends.e1d0d86853b923a8cd7d7254c28dfcf7.svg";
export { ForwardRef as ReactComponent };